var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8703 7.32909L10.9981 14.0281L4.12581 7.32909C4.00303 7.20915 3.8382 7.142 3.66656 7.142C3.49492 7.142 3.33009 7.20915 3.20731 7.32909C3.14786 7.38734 3.10063 7.45687 3.06838 7.5336C3.03614 7.61034 3.01953 7.69273 3.01953 7.77596C3.01953 7.8592 3.03614 7.94159 3.06838 8.01833C3.10063 8.09506 3.14786 8.16459 3.20731 8.22284L10.5182 15.3508C10.6466 15.476 10.8188 15.546 10.9981 15.546C11.1773 15.546 11.3495 15.476 11.4779 15.3508L18.7888 8.22421C18.8487 8.16592 18.8963 8.09622 18.9288 8.01923C18.9613 7.94225 18.978 7.85953 18.978 7.77596C18.978 7.6924 18.9613 7.60968 18.9288 7.5327C18.8963 7.45571 18.8487 7.38601 18.7888 7.32771C18.666 7.20777 18.5012 7.14062 18.3296 7.14062C18.1579 7.14062 17.9931 7.20777 17.8703 7.32771V7.32909Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownIcon);
export default __webpack_public_path__ + "static/media/downIcon.fa6acf0948b6024c8afd2c6356de7b79.svg";
export { ForwardRef as ReactComponent };